import { config } from '@/config/env';
import { AdaptadorHttp } from './AdaptadorHttp';
import { AdaptadorLocal } from './AdaptadorLocal';
import type { PuertoDeIdentidad } from './puerto';

/**
 * El único archivo del repo que nombra un adaptador.
 *
 * Esa frase es el punto entero de la fase, y no es un deseo:
 * `soloElPuerto.test.ts` lee el árbol de `src/` y **falla** si cualquier otro
 * archivo —fuera de las pruebas de esta carpeta— importa `AdaptadorLocal` o
 * `AdaptadorHttp`.
 *
 * Y aquí está lo que esa regla compró: **cambiar de adaptador fue editar estas
 * tres líneas y ninguna otra.** Ni una pantalla, ni una prueba de pantalla, ni
 * el router. Lo único que notan es que `esDeMentira` pasa a `false` y el aviso
 * rojo se apaga solo.
 *
 * La elección es por configuración y no por etapa: `config.capitalApiUrl` vacía
 * significa «el área no está conectada en este entorno», y entonces el local
 * —que se anuncia como simulación— es mejor que una pantalla que no entra.
 */
export const puerto: PuertoDeIdentidad = config.capitalApiUrl
  ? new AdaptadorHttp(config.capitalApiUrl)
  : new AdaptadorLocal();
